import { TaskResultData } from '@/internal-app/pages/tasks/taskResultData'
import { WhiteBox } from '@/components/Layout'
import React, { useEffect, useState } from 'react'
import { useLocalization } from '@/hooks/localization'
import { Button } from '@/components/button'
import { useDispatch } from '@/hooks/dispatch'
import { openDialog } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import { actionCreators as taskActions } from '@/store/myTasks'
import { workflowTaskStatus } from '@/enums/workflowTaskStatus'
import { usePermissionChecker } from '@/hooks/usePermissionChecker'
import context from '@/context'
import { useReduxState } from '@/hooks/reduxState'

function TaskResultViewer ({ task, isActive }) {
  const [canReassign, setCanReassign] = useState(false)
  const isGranted = usePermissionChecker()
  const { localize } = useLocalization()
  const actions = useDispatch({
    openDialog,
    updateResultData: taskActions.updateResultData
  })
  const userId = useReduxState(state => Number(state.identity.user.profile.sub))

  useEffect(() => {
    if (task.data.resultType === 3 && task.status === workflowTaskStatus.enum.Closed) {
      if (!isGranted('CanReassignTask')) {
        if (task.assignedToUserId !== userId) {
          context.api.ticketService.get(task.ticketId).then(ticket => {
            setCanReassign(ticket.authorId === userId)
          }).catch(() => setCanReassign(false))
        } else {
          setCanReassign(true)
        }
      } else {
        setCanReassign(true)
      }
    }
  }, [task.data.resultType, task.status, task.assignedToUserId, task.ticketId, isGranted, userId])

  if (task.data.resultType >= 2) { // ButtonsOnly / ChangeRequest does not have special task result
    // don't show edit button if task is closed, unless it's a complex task result like message(resultType 4)
    const buttons = (task.status !== workflowTaskStatus.enum.Closed || task.data.resultType === 4) && (isActive || canReassign) ? (
      <Button icon='pencil' color='primary' onClick={() => actions.openDialog({
        dialogType: dialogTypes.taskResultEditor,
        task: task,
        onAction: actions.updateResultData
      })}>{localize('Common.Edit')}</Button>
    ) : null
    return (
      <WhiteBox
        header='Tasks.TaskResult'
        buttons={buttons}>
        <TaskResultData task={task} showDetail={!buttons} />
      </WhiteBox>
    )
  }
  return null
}

export {
  TaskResultViewer
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/tasks/taskResultViewer.js